import { dew as _validCallableDew } from "./valid-callable";
import { dew as _validValueDew } from "./valid-value";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var callable = _validCallableDew(),
      value = _validValueDew(),
      bind = Function.prototype.bind,
      call = Function.prototype.call,
      keys = Object.keys,
      objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;

  exports = function (method, defVal) {
    return function (obj, cb
    /*, thisArg, compareFn*/
    ) {
      var list,
          thisArg = arguments[2],
          compareFn = arguments[3];
      obj = Object(value(obj));
      callable(cb);
      list = keys(obj);

      if (compareFn) {
        list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
      }

      if (typeof method !== "function") method = list[method];
      return call.call(method, list, function (key, index) {
        if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
        return call.call(cb, thisArg, obj[key], key, obj, index);
      });
    };
  };

  return exports;
}